const draggableService = {
  dragStart(event, index, draggableVariables, currentElemIndex) {
    draggableVariables.pointIndex = index;
    draggableVariables.selected = event.target;
    draggableVariables.offsetX = event.offsetX;
    draggableVariables.offsetY = event.offsetY;
    draggableVariables.currentElementIndex = currentElemIndex;
    draggableVariables.mouseX = event.target.parentNode.parentNode.offsetLeft;
    draggableVariables.mouseY = event.target.parentNode.parentNode.offsetTop;
    // :todo changed this.elemX and this.elemY to equal layerX and layerY respectively cuz have different values depend on user-agent, be careful layerX & layerY is NOT STANDARD and it's implementation can be changed in future
    // draggableVariables.elemX = event.offsetX;
    // draggableVariables.elemY = event.offsetY;
    draggableVariables.elemX = event.layerX;
    draggableVariables.elemY = event.layerY;
    console.log('event ', event);
  },
  move(event, draggableVariables, arrayIndex, story, refs, pointsFlag, containerWidthAndHeight) {
    let leftMouseIndentation = event.pageX - draggableVariables.mouseX - draggableVariables.elemX;
    let topMouseIndentation = event.pageY - draggableVariables.mouseY - draggableVariables.elemY;
    // let leftLimit = draggableVariables.selected.parentNode.clientWidth - draggableVariables.selected.clientWidth;
    // let topLimit = draggableVariables.selected.parentNode.clientHeight - draggableVariables.selected.clientHeight;
    let xPoint = null;
    let yPoint = null;
    let positionY = null;
    let positionX = null;
    let stampPosition = null;
    let pointPosition = {};
    let staticPoints = {};

    draggableVariables.selected.style.left = leftMouseIndentation + 'px';
    draggableVariables.selected.style.top = topMouseIndentation + 'px';
    // This logic for static type stamps
    xPoint = parseInt(draggableVariables.selected.style.left.replace('px', ''), 10) + (draggableVariables.selected.offsetWidth / 2);
    yPoint = parseInt(draggableVariables.selected.style.top.replace('px', ''), 10) + (draggableVariables.selected.offsetHeight / 2);

    // If condition find Y position letter
    if (yPoint <= containerWidthAndHeight.height / 4) {
      positionY = 't';
    } else if (yPoint > containerWidthAndHeight.height / 4 && yPoint <= containerWidthAndHeight.height * 0.75) {
      positionY = 'm';
    } else if (yPoint > containerWidthAndHeight.height * 0.75) {
      positionY = 'b';
    }
    // If condition find X position letter
    if (xPoint <= containerWidthAndHeight.width / 4) {
      positionX = 'l';
    } else if (xPoint > containerWidthAndHeight.width / 4 && xPoint <= containerWidthAndHeight.width * 0.75) {
      positionX = 'c';
    } else if (xPoint > containerWidthAndHeight.width * 0.75) {
      positionX = 'r';
    }
    stampPosition = positionY + positionX;

    // Depend on stamp position get position coordinates(x and y)
    if (positionX === 'l') {
      pointPosition.x = 0;
    } else if (positionX === 'c') {
      pointPosition.x = containerWidthAndHeight.width / 2;
    } else if (positionX === 'r') {
      pointPosition.x = containerWidthAndHeight.width;
    }
    if (positionY === 't') {
      pointPosition.y = 0;
    } else if (positionY === 'm') {
      pointPosition.y = containerWidthAndHeight.height / 2;
    } else if (positionY === 'b') {
      pointPosition.y = containerWidthAndHeight.height;
    }


    // console.log('event ', event);

    // Conditions for limitation border of dragging
    // todo: changing offsetX,Y to layerX,Y cuz have problems in Safari and if/else conditions too
    if (draggableVariables.elemX + draggableVariables.selected.offsetLeft >= containerWidthAndHeight.width) {
      // draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.offsetX + 'px';
      draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.elemX + 'px';
      console.error('too much');
    } else if (draggableVariables.elemX + draggableVariables.selected.offsetLeft <= 0) {
      // draggableVariables.selected.style.left = -draggableVariables.offsetX + 'px';
      draggableVariables.selected.style.left = -draggableVariables.elemX + 'px';
      console.warn('too few');
    }
    if (draggableVariables.elemY + draggableVariables.selected.offsetTop >= containerWidthAndHeight.height) {
      // draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.offsetY + 'px';
      draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.elemY + 'px';
      console.error('too much');
    } else if (draggableVariables.elemY + draggableVariables.selected.offsetTop <= 0) {
      // draggableVariables.selected.style.top = -draggableVariables.offsetY + 'px';
      draggableVariables.selected.style.top = -draggableVariables.elemY + 'px';
      console.warn('too few');
    }
    // X coordinate for point
    staticPoints.x = pointPosition.x - draggableVariables.selected.offsetLeft;
    // Y coordinate for point
    staticPoints.y = pointPosition.y - draggableVariables.selected.offsetTop;

    if (story.data.content[arrayIndex]) {
      story.data.content[arrayIndex].points[draggableVariables.pointIndex] = {
        x: staticPoints.x * (4 / 3),
        y: staticPoints.y * (4 / 3)
      };
      story.data.content[arrayIndex].position = stampPosition;
      story.data.content[arrayIndex].staticOffset = {
        x: parseInt(draggableVariables.selected.style.left.replace('px', ''), 10),
        y: parseInt(draggableVariables.selected.style.top.replace('px', ''), 10)
      };
    }
    // console.log('draggableVariables.selected.style ', draggableVariables.selected.style.left);
  },
  dragDestroy(draggableVariables) {
    draggableVariables.selected = null;
  },
  // fixme: Below functions is for Scale and Resize
  dragStartScaleResize(event, index, scaleResizeVariables, currentElemIndex, container) {
    scaleResizeVariables.pointIndex = index;
    scaleResizeVariables.offsetX = event.offsetX;
    scaleResizeVariables.offsetY = event.offsetY;
    scaleResizeVariables.currentElementIndex = currentElemIndex;
    scaleResizeVariables.selected = event.target;
    scaleResizeVariables.mouseX = event.target.parentNode.offsetLeft;
    scaleResizeVariables.mouseY = event.target.parentNode.offsetTop;
    scaleResizeVariables.containerX = container.offsetLeft;
    scaleResizeVariables.containerY = container.offsetTop;
    // :todo changed this.elemX and this.elemY to equal layerX and layerY respectively cuz have different values depend on user-agent, be careful layerX & layerY is NOT STANDARD and it's implementation can be changed in future
    scaleResizeVariables.elemX = event.offsetX;
    scaleResizeVariables.elemY = event.offsetY;
    // console.log('scaleResizeVariables.selected = event.target ', scaleResizeVariables.selected = event.target);
    // scaleResizeVariables.elemX = event.layerX;
    // scaleResizeVariables.elemY = event.layerY;
  },
  moveScaleResize(event, scaleResizeVariables) {
    let leftMouseIndentation = event.pageX - scaleResizeVariables.mouseX - scaleResizeVariables.containerX - scaleResizeVariables.elemX;
    let topMouseIndentation = event.pageY - scaleResizeVariables.mouseY - scaleResizeVariables.containerY - scaleResizeVariables.elemY;
    let xPoint = null;
    let yPoint = null;

    // This logic for static type stamps
    xPoint = leftMouseIndentation + (scaleResizeVariables.selected.offsetWidth / 2);
    yPoint = topMouseIndentation + (scaleResizeVariables.selected.offsetHeight / 2);
    scaleResizeVariables.xPoint = xPoint;
    scaleResizeVariables.yPoint = yPoint;
  },
  moveEyesLips(event, draggableVariables, stampIndex, story, refs, pointsFlag, containerWidthAndHeight) {
    // let leftMouseIndentation = event.pageX - draggableVariables.mouseX - draggableVariables.offsetX;
    let leftMouseIndentation = event.pageX - draggableVariables.mouseX - draggableVariables.elemX;
    let topMouseIndentation = event.pageY - draggableVariables.mouseY - draggableVariables.elemY;
    // let topMouseIndentation = event.pageY - draggableVariables.mouseY - draggableVariables.offsetY;
    draggableVariables.selected.style.left = leftMouseIndentation + 'px';
    draggableVariables.selected.style.top = topMouseIndentation + 'px';
    draggableVariables.pivot_id = story.data.content[stampIndex].pivot_id;

    // Conditions for limitation border of dragging
    // todo: changing offsetX,Y to layerX,Y cuz have problems in Safari and if/else conditions
    if (draggableVariables.elemX + draggableVariables.selected.offsetLeft >= containerWidthAndHeight.width) {
      // draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.offsetX + 'px';
      draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.elemX + 'px';
      console.error('too much');
    } else if (draggableVariables.elemX + draggableVariables.selected.offsetLeft <= 0) {
      // draggableVariables.selected.style.left = -draggableVariables.offsetX + 'px';
      draggableVariables.selected.style.left = -draggableVariables.elemX + 'px';
      console.warn('too few');
    }

    if (draggableVariables.elemY + draggableVariables.selected.offsetTop >= containerWidthAndHeight.height) {
      // draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.offsetY + 'px';
      draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.elemY + 'px';
      console.error('too much');
    } else if (draggableVariables.elemY + draggableVariables.selected.offsetTop <= 0) {
      // draggableVariables.selected.style.top = -draggableVariables.offsetY + 'px';
      draggableVariables.selected.style.top = -draggableVariables.elemY + 'px';
      console.warn('too few');
    }
  },

};

export default draggableService;




// WEBPACK FOOTER //
// ./src/js/draggable-service.js